const getParameters = () => {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  return params;
};

const getData = () => {
  const fallback = '';

  let parameters =
    getParameters().get('contentdata') !== null
      ? JSON.parse(b64DecodeUnicode(getParameters().get('contentdata')))
      : fallback !== ''
      ? JSON.parse(b64DecodeUnicode(fallback))
      : [];
  return parameters;
};

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  // https://stackoverflow.com/a/30106551
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
}

const getHost = () => {
  let thisHost = getParameters().get('host');
  if (!thisHost || thisHost == '') {
    thisHost = window.parent.location.href;
  }
  return thisHost;
};

const getContainerId = () => {
  let containerId = getParameters().get('containerid');
  return containerId;
};

const parameters = getData();
const host = getHost();
const containerId = getContainerId();

export default {
  host,
  containerId,
  parameters
};
